import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FAQ } from '../faq-list.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'miq-faq-list-item',
  templateUrl: './faq-list-item.component.html',
  styleUrls: ['./faq-list-item.component.scss'],
  standalone: false,
})
export class FaqListItemComponent implements OnInit {
  @Input() faq: FAQ;
  @Output() likeFaqEvent = new EventEmitter<any>();
  @Output() deleteFaqEvent = new EventEmitter<any>();
  @Output() private updateFaqEvent = new EventEmitter<any>();

  showMore = false;
  faqFormGroup: UntypedFormGroup;

  ngOnInit() {
    this.faqFormGroup = new UntypedFormGroup({
      question: new UntypedFormControl(this.faq.question, [Validators.required, Validators.maxLength(255)]),
      answer: new UntypedFormControl(this.faq.answer, [Validators.required]),
    });
  }

  onFaqChange() {
    const { question, answer } = this.faqFormGroup.value;
    this.updateFaqEvent.emit({
      ...this.faq,
      question,
      answer,
    });
  }
}
